import { useCallback } from 'react';
import { useGetStreamData } from '../useGetStreamData';

export const useUpdateSystemInfo = () => {
	const { getStreamData } = useGetStreamData();

	const updateSystemInfo = useCallback(
		(prevState, stream) => {
			const system = { ...prevState.system };
			if (stream['/status']) {
				const sys_status = getStreamData(stream, '/status');
				if (stream['/status_text'])
					system.status_text = getStreamData(stream, '/status_text');
				if (sys_status === 'ok') system.status = '✔️';
				else if (sys_status === 'warning') system.status = '⚠️';
				else system.status = '⛔';
			}
			if (stream['/server_status']) {
				system.server_status =
					getStreamData(stream, '/server_status') === 'connected';
			}
			return system;
		},
		[getStreamData],
	);

	return { updateSystemInfo };
};
